import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
  Menu,
  FormControl,
} from "@mui/material";
import moment from "moment";
import { LoadingButton } from "@mui/lab";
import Calander from "../../../assets/icons/Calander.svg";
import { DateEditCalendar } from "../../CommonComponent/DateEditCalendar";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import {
  addChecklistTypeMastersList,
  getDepartmentMasterList,
} from "../../../redux/actions/mastersAction";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  DateTimePicker,
  LocalizationProvider,
  TimePicker,
} from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { renderTimeViewClock } from "@mui/x-date-pickers/timeViewRenderers";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import {
  setIsOpenModelEditChecklistTypeMaster,
  updateChecklistTypeMastersList,
} from "../../../redux/actions/mastersAction";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

const EditChecklistTypeMasterModel = (Props) => {
  const dispatch = useDispatch();
  const CompanyID = localStorage.getItem("companyID");
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );

  const EditChecklistTypeMasterModel = useSelector(
    (state) => state?.masters?.EditChecklistTypeMasterModel
  );

  console.log("fhjwkfgahfi", EditChecklistTypeMasterModel?.EditRowDataModel);
  const departmentMasterData = useSelector(
    (state) => state?.masters?.departmentMasterData
  );

  const currentdatetime = moment().format("YYYY-MM-DDTHH:mm:ss");

  const [ChecklistTypeData, setChecklistTypeData] = useState({
    ChecklistType: "",
    Department: "",
    Frequency: "",
    GracePeriod: "",
  });

  const [PublishDate, setPublishDate] = useState();
  console.log(
    "dh3kjgchiwehgci",
    EditChecklistTypeMasterModel?.EditRowDataModel?.publish_date
  );
  useEffect(() => {
    setChecklistTypeData({
      ChecklistType: EditChecklistTypeMasterModel?.EditRowDataModel?.name,
      Department:
        EditChecklistTypeMasterModel?.EditRowDataModel?.department_id || "",
      Frequency: EditChecklistTypeMasterModel?.EditRowDataModel?.set_trigger,
      GracePeriod: EditChecklistTypeMasterModel?.EditRowDataModel?.grace_period,
    });
    setPublishDate(
      dayjs(EditChecklistTypeMasterModel?.EditRowDataModel?.publish_date)
    );
  }, [EditChecklistTypeMasterModel]);

  const handleChangePublishDate = (newValue) => {
    setPublishDate(newValue);
  };

  const handleChangeChecklistTypeData = (e) => {
    const { name, value } = e.target;
    setChecklistTypeData({ ...ChecklistTypeData, [name]: value });
  };
  const handleSaveChecklistType = async (event) => {
    event.preventDefault();
    if (
      ChecklistTypeData?.ChecklistType !== "" &&
      ChecklistTypeData?.Department !== "" &&
      ChecklistTypeData?.Frequency !== "" &&
      ChecklistTypeData?.GracePeriod !== ""
    ) {
      dispatch(
        updateChecklistTypeMastersList({
          name: ChecklistTypeData?.ChecklistType,
          set_trigger: ChecklistTypeData?.Frequency,
          publish_date: PublishDate?.format("YYYY-MM-DDTHH:mm:ss"),
          department_id: ChecklistTypeData?.Department,
          grace_period: ChecklistTypeData?.GracePeriod,
          company_id: CompanyID,
          id: EditChecklistTypeMasterModel?.EditRowDataModel?.id,
        })
      );
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  useEffect(() => {
    dispatch(
      getDepartmentMasterList({
        companyId: CompanyID,
      })
    );
  }, []);

  return (
    <Modal
      open={EditChecklistTypeMasterModel?.isOpenEditModel}
      onClose={() => {
        const payload = {
          isOpenEditModel: false,
          EditRowDataModel: [],
        };
        dispatch(setIsOpenModelEditChecklistTypeMaster(payload));
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Edit Checklist Type Master
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                const payload = {
                  isOpenEditModel: false,
                  EditRowDataModel: [],
                };
                dispatch(setIsOpenModelEditChecklistTypeMaster(payload));
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Checklist Type Name"
                type="text"
                name="ChecklistType"
                value={ChecklistTypeData?.ChecklistType}
                onChange={handleChangeChecklistTypeData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box sx={{ mb: "15px" }}>
              <FormControl
                fullWidth
                sx={{
                  background: "#F3F6F9",
                  borderRadius: "10px",
                  ".css-mqlm8o-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                    {
                      height: "3.5rem",
                    },
                }}
              >
                <Select
                  name="Department"
                  value={ChecklistTypeData?.Department}
                  onChange={handleChangeChecklistTypeData}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    height: "40px",
                    borderRadius: "10px",
                    fontSize: "14px",
                    color: "#000000",
                    border: "none",
                    " .css-16ak6nl-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root":
                      {
                        height: "100%",
                        width: "41rem",
                        lineHeight: "none",
                        borderRadius: "10px",
                        backgroundColor: "#F3F6F9",
                      },
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "0px solid #F3F6F9",
                    },
                    "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                      border: "0px solid #F3F6F9",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                >
                  <MenuItem value="" disabled>
                    Select Department Name
                  </MenuItem>
                  {departmentMasterData?.map((row) => (
                    <MenuItem value={row?.id}>{row?.name}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ mb: "20px" }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer
                  components={["DateTimePicker", "DateTimePicker"]}
                  sx={{
                    "& .css-o9k5xi-MuiInputBase-root-MuiOutlinedInput-root": {
                      background: "#F3F6F9",
                      border: "0px solid #F3F6F9",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      border: "none",
                    },
                    "& .css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input":
                      {
                        background: "#F3F6F9",
                        border: "0px solid #F3F6F9",
                      },
                  }}
                >
                  <DateTimePicker
                    name="PublishDate"
                    value={PublishDate}
                    onChange={handleChangePublishDate}
                    viewRenderers={{
                      hours: renderTimeViewClock,
                      minutes: renderTimeViewClock,
                      seconds: renderTimeViewClock,
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Frequency (In Days)"
                type="number"
                name="Frequency"
                value={ChecklistTypeData?.Frequency}
                onChange={handleChangeChecklistTypeData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Grace Period (In Days)"
                type="number"
                name="GracePeriod"
                value={ChecklistTypeData?.GracePeriod}
                onChange={handleChangeChecklistTypeData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  // backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                  // ":hover": {
                  //   backgroundColor: "#26875C",
                  // },
                }}
                onClick={() => {
                  const payload = {
                    isOpenEditModel: false,
                    EditRowDataModel: [],
                  };
                  dispatch(setIsOpenModelEditChecklistTypeMaster(payload));
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveChecklistType}
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default EditChecklistTypeMasterModel;
